import React from 'react'
import styles from './StudentwiseAnalytics.module.css'
import { Col, Row, Table } from 'react-bootstrap'

const StudentwiseAnalytics = () => {
  return (
    <div className={styles.section}>
      <div className={`${styles.bordered} my-3 mx-0 mx-md-2 mx-lg-3`}>
        <h1 className={styles.heading}>Trupthi Agarwal</h1>
        <Row>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              Roll No:<span> 5365463</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              Class: <span>13</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              Test ID: <span>42325</span>
            </p>
          </Col>
          <Col className="mb-2" lg={12}>
            <p className={styles.text}>
              No Of Students: <span>124</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              No of Questions: <span>090</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              Total Marks: <span>300</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p className={styles.text}>
              Test Duration: <span>90 Min</span>
            </p>
          </Col>
        </Row>
      </div>
      <div className="my-5">
        <div className={styles.cards}>
          <div className={`${styles.card} ${styles.bordered}`}>
            <h4>95</h4>
            <div>
              <p>Physics</p>
              <p>Max. Obt. Marks</p>
            </div>
          </div>
          <div className={`${styles.card} ${styles.bordered}`}>
          <h4>72</h4>
            <div>
              <p>Chemistry</p>
              <p>Max. Obt. Marks</p>
            </div>
          </div>
          <div className={`${styles.card} ${styles.bordered}`}>
          <h4>100</h4>
            <div>
              <p>Maths</p>
              <p>Max. Obt. Marks</p>
            </div>
          </div>
        </div>
      </div>
      {/* Paper analysis section */}
      <div className="my-5">
        <h3 className={styles.paperheading}>Paper Analysis</h3>
        <div className={styles.brdr}>
        <Row>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p>
            RA:<span> Right Answer</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p>
              UA: <span>User Answer</span>
            </p>
          </Col>
          <Col className="mb-2" lg={4} md={6} sm={12}>
            <p>
            NA: <span>Not Attempted</span>
            </p>
          </Col>
          <Col className="mb-2 mb-md-0" lg={4} md={6} sm={12}>
            <p>
            CA: <span>Attempted & Correct</span>
            </p>
          </Col>
          <Col className="mb-2 mb-md-0" lg={4} md={6} sm={12}/>
          <Col className="mb-2 mb-md-0" lg={4} md={6} sm={12}>
            <p>
            IA: <span>Attempted but Incorrect</span>
            </p>
          </Col>
        </Row>
        </div>
        <div className={styles.table}>
        <Table responsive bordered className='mb-0'>
          <thead className={styles.thead}>
            <tr>
              <th>Q.No.</th>
              <th>SUB</th>
              <th>RA</th>
              <th>UA</th>
              <th>CA%</th>
              <th>IA%</th>
              <th>NA%</th>
              <th>Level</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
            </tr>
          </tbody>
        </Table>
        </div>
      </div>
      {/* Rank analysis section */}
      <div className="my-5">
        <h3 className={styles.paperheading}>Rank Analysis</h3>
        <div className={styles.brdr}>
          <div className='d-flex flex-column flex-md-row gap-2 justify-content-between mb-2'>
            <p> TM:<span> Total Marks</span></p>
            <p> E:<span> Easy</span></p>
            <p> T:<span> Tough</span></p>
            <p> H:<span> Hard</span></p>
            <p> M:<span> Marks</span></p>
            <p> R:<span> Rank</span></p>
          </div>
          <div className='d-flex flex-column flex-md-row gap-2 justify-content-between'>
            <p> CQ: <span>Correct Questions</span></p>
            <p> IQ: <span>Incorrect Questions</span></p>
            <p> UQ: <span>Unattempted Questions</span></p>
          </div>
        </div>
        <p className={styles.note}>Note: Question Toughness Analysis in T,M,E (Correct Questions/Attempt Question[Not Attempt Questions])</p>
        <div className={styles.table}>
        <Table responsive bordered className='mb-0'>
          <thead className={styles.thead}>
            <tr>
              <th rowSpan={2}>R</th>
              <th rowSpan={2}>TM</th>
              <th rowSpan={2}>Roll.No</th>
              <th rowSpan={2}>CQ</th>
              <th rowSpan={2}>IQ</th>
              <th rowSpan={2}>UQ</th>
              <th rowSpan={1} colSpan={2}>Physi</th>
              <th rowSpan={1} colSpan={2}>Chemi</th>
              <th rowSpan={1} colSpan={2}>Maths</th>
              <th rowSpan={2}>T</th>
              <th rowSpan={2}>M</th>
              <th rowSpan={2}>E</th>
            </tr>
            <tr>
              <th rowSpan={1} colSpan={1}>R</th>
              <th rowSpan={1} colSpan={1}>M</th>
              <th rowSpan={1} colSpan={1}>R</th>
              <th rowSpan={1} colSpan={1}>M</th>
              <th rowSpan={1} colSpan={1}>R</th>
              <th rowSpan={1} colSpan={1}>M</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
            </tr>
            <tr>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
            </tr>
            <tr>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td className={styles.td}>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
            </tr>
          </tbody>
        </Table>
        </div>
      </div>
    </div>
  );
}

export default StudentwiseAnalytics